import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DateAdapter } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { ScreenType } from 'src/app/enums/ScreenType';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { UserRegDetails } from 'src/app/models/user';
import { IUserEvents } from 'src/app/models/user-events';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-inventory-form-dialog',
  templateUrl: './inventory-form-dialog.component.html',
  styleUrls: ['./inventory-form-dialog.component.scss'],
})
export class InventoryFormDialogComponent implements OnInit {
  inventoryForm: FormGroup;
  inventoryItems: FormArray;
  isShowSaveMessage = false;
  userEvents: IUserEvents[] = [];
  userList: UserRegDetails[] = [];
  filteredUsers: UserRegDetails[] = [];
  hostFilter = new FormControl();
  minDate: Date;
  maxDate: Date;
  userId: string = null;
  currentAddress: string = null;
  isAddressAvailable = false;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  vendorRequests: ComplaintsTickets[] = [];
  @Output() onSaveInventory = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private adapter: DateAdapter<any>,
    private encryptionService: EncryptionService
  ) {
    this.userEvents = data.userEvents;
    this.userEvents = data.userEvents;
    this.userList = data.users;
    this.vendorRequests = data.vendorRequests;
    this.screenSize = data.screen;
    this.minDate = new Date(); // Set minimum date to today
    this.maxDate = new Date(); // Set maximum date to one month from today
    this.maxDate.setMonth(this.maxDate.getMonth() + 1); // Add one month
    this.adapter.setLocale('en'); // Set locale (optional)
  }

  ngOnInit(): void {
    this.userId = this.encryptionService.getCurrentUser().role;
    this.inventoryForm = this.formBuilder.group({
      listName: ['', [Validators.required]],
      items: this.formBuilder.array([]), // FormArray for dynamic items
      // discount: [null, [Validators.required]],
      // billAmount: [null, [Validators.required]],
      assignEvent: [null],
      assignVendor: [null],
      deliveryDate: [''],
      deliveryBy: [''],
      deliveryByUserId: [''],
      deliveryByEmail: [''],
      deliveryAddress: ['', [Validators.required]],
      addressType: ['', [Validators.required]],
      sendCode: [false, [Validators.required]],
    });
    this.inventoryItems = this.inventoryForm.get('items') as FormArray;
    this.filteredUsers = this.data.users;
    this.hostFilter.valueChanges.subscribe((value) => {
      this.filteredUsers = this.filterHosts(value);
    });

    this.currentAddress = this.userList.filter(
      (x) => x.userId.toLowerCase() == this.userId.toLowerCase()
    )[0].userAddress;
    if (this.currentAddress) {
      this.isAddressAvailable = true;
    }
    this.addItem();
  }
  filterHosts(value: string) {
    const filterValue = value.toLowerCase();
    return this.data.users.filter((host: any) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  addItem(): void {
    const itemGroup = this.formBuilder.group({
      itemName: ['', [Validators.required]],
      units: ['', [Validators.required]],
      quantity: [, [Validators.required, Validators.min(1)]],
    });
    this.inventoryItems.push(itemGroup); // Add new item to inventoryItems
  }
  hostSelect(val: MatAutocompleteSelectedEvent) {
    this.data.users.forEach((item: any) => {
      if (item.firstname + ' ' + item.lastname === val.option.value) {
        this.inventoryForm.controls['deliveryByEmail'].setValue(item.email);
        this.inventoryForm.controls['deliveryByUserId'].setValue(item.userId);
        this.inventoryForm.controls['deliveryBy'].setValue(
          item.firstname + ' ' + item.lastname
        );
      }
    });
  }

  removeItem(index: number): void {
    this.inventoryItems.removeAt(index); // Remove item from inventoryItems
  }
  isAddButtonDisabled(): boolean {
    if (this.inventoryItems.controls.length === 1) {
      const singleItem = this.inventoryItems.controls[0];
      return singleItem.invalid;
    } else {
      const lastItem =
        this.inventoryItems.controls[this.inventoryItems.controls.length - 1];
      return lastItem.invalid;
    }
  }
  onSaveForm() {
    this.isShowSaveMessage = true;
    if (!this.inventoryForm.controls['deliveryDate'].value) {
      this.inventoryForm.controls['deliveryDate'].setValue(new Date());
    }
    this.onSaveInventory.emit(this.inventoryForm.value);
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  onAddressTypeChange(event: MatRadioChange) {
    const selectedValue = event.value;
    if (selectedValue == '1') {
      this.inventoryForm.controls['deliveryAddress'].setValue(
        this.currentAddress
      );
    }
  }
  onCheckboxChange() {}
}
